import React from "react";
import { Typography, Box, ListItem, Button, Tooltip, DialogTitle, Dialog, DialogActions } from "@mui/material";
// import { HeldIcon, PerformingIcon, ReadyPerformIcon } from "./StaticData/index";
// import ProgressMeeting from "../LComponents/ProgressMeeting/ProgressMeeting";
// import DyStyledBadge from "../../../../components/GlobalComponents/DyStyledBadge/DyStyledBadge";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import { baseUrl } from "../../../../env"
import { useState, useEffect } from "react";
// import * as moment from "jalali-moment";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { IconButton } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useDeleteMeeting } from "../../../Meeting/Hooks";
import { setInitialTreeViewR, setMeetingIdR } from "../../../Meeting/MeetingsSlice/MeetingsSlice";
import Grid from "@mui/material/Grid";

const AlignmentCart1 = ({
  info,
  setMeetId,
  setDeleteMeetState,
  prog,
  setShowToastMessage,
  bank,
  accessForReport,
  setShowDownlodLink,
  setPMeetingId,
  setshowEditMeeting,
}: any) => {
  const userId = useSelector((state: any) => state.loign.userInfo.userId);
  const tenantId: any = useSelector(
    (state: any) => state.meetings.profileTenantId
  );

  let {global} : any = info;
//   const [deleteIds, setDeleteIds] = useState<any>();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [meetingId, setMeetingId] = useState<string>("");
  const getDetSuccess = () => {
    navigate("/alignmentCompanyTeams", { replace: true });
  };
  const getDetFailed = () => {};

  const LoginMeeting = async () => {
    try {
      dispatch(setInitialTreeViewR());
      let { meetingDate, id } = info;
      setMeetingId(id);
      setMeetId(id);
      let meetDetail = {
        id: id,
        meetingDate: meetingDate,
      };
      dispatch(setMeetingIdR(meetDetail));
    } catch (error) {
    }
  };
  const { mutate: deleteMeeting ,isError,isSuccess,data:deleteData} = useDeleteMeeting();
  const initialDeleteMeeting = () => {
    let { id } = info;
    let ids = {
      tenantId: tenantId,
      userId: userId,
      deletedId: id,
    };
    deleteMeeting(ids);
    handleClose();
  };
  useEffect(() => {
    if (deleteData) {
      setShowToastMessage(true);
      setDeleteMeetState(deleteData?.data)
    }
  }, [isSuccess,deleteData])

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    // <Card sx={{ width: "30%", height:"30%", boxShadow: 6, borderRadius: 5 }}>
      // <CardContent>
          // <Grid>
        //   <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
        //   <Box>
        //     <DyButton
        //       caption={"دعوت همکاران"}
        //       onClick={initialAddStaff}
        //       color={"red"}
        //       disbled={false}
        //       variant={"contained"}
        //       type={"button"}
        //       bgColor={"#00387C"}
        //     />
        //   </Box>
        // </Box>
        <Grid container>
        <Grid item xs={12} md={12} mx={2}>
          <Box
          display={"flex"} flexDirection={"row-reverse"}
          // justifyContent={"flex-start"} // تغییر به سمت چپ
          bgcolor={"#00387C"}
          borderRadius={2}
          maxHeight={"25px"}
          width={"95px"}
            >
            <Button
              variant="text"
              onClick={() => {
                LoginMeeting();
              }}
              >
              <Typography color={"white"} fontSize={"12px"}>
                ورود به جلسه
              </Typography>
            </Button>
          </Box>
         </Grid>
         </Grid>
      // </CardContent>
    // </Card>
  );
};

export default AlignmentCart1;
